import { Userbot } from "../interfaces"

/** Only the server's explicit metadata is provenance; caller context is ignored. */
export const normalizeReportProvenance = (
  report: Partial<Userbot.ReportProvenance>,
): Userbot.ReportProvenance => ({
  origin: report.origin ?? null,
  scheduleId: report.scheduleId ?? null,
  runId: report.runId ?? null,
  groupId: report.groupId ?? null,
  itemId: report.itemId ?? null,
})
